import {CreditRequestAttachmentModel} from '../../model/credit/credit-request-attachment.model';
import {CreditRequestClassificationEnum} from '../../model/credit/credit-request-classification.enum';
import {CreditRequestModuleEnum} from '../../model/credit/credit-request-module.enum';
import {CreditRequestPriorityEnum} from '../../model/credit/credit-request-priority.enum';
import {CreditRequestModel} from '../../model/credit/credit-request.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace CreditRequestController {
  export type QueryCreditRequestsRes = {
    total: number
    available: any
    items: CreditRequestModel[]
  }

  export const queryCreditRequests = async (searchable: Searchable) =>
    (await axios.put<QueryCreditRequestsRes>(`/internal/credit/requests`, searchable)).data

  export type CreateCreditRequestReq = {
    organizationId: string
    accountId: number
    title: string
    description: string
    module: CreditRequestModuleEnum
    priority: CreditRequestPriorityEnum
    requestEstimateBeforeStart: boolean
    requireEstimateAcceptance: boolean
  }

  export type CreateCreditRequestRes = {
    id: string
  }

  export const createCreditRequestAdmin = async (request: CreateCreditRequestReq) =>
    (await axios.post<CreateCreditRequestRes>(`/internal/credit/requests`, request)).data

  export const reorderCreditRequests = async (orderedIds: string[]) =>
    (await axios.put(`/internal/credit/requests/reorder`, {orderedIds: orderedIds}))

  export const getCreditRequest = async (requestId: string) =>
    (await axios.get<CreditRequestModel>(`/internal/credit/requests/${requestId}`)).data

  export type EstimateReq = {
    hours: number
    deliveryDays: number
    classification: CreditRequestClassificationEnum
    proposedSolution?: string | null
    comment?: string | null
  }

  export const estimateCreditRequest = async (requestId: string, version: number, request: EstimateReq) =>
    (await axios.put(`/internal/credit/requests/${requestId}/estimate?version=${version}`, request))

  export const startCreditRequest = async (requestId: string, version: number) =>
    (await axios.put(`/internal/credit/requests/${requestId}/start?version=${version}`))

  export type AssignOwnerReq = {
    ownerAccountId: string
  }

  export const assignCreditRequestOwner = async (requestId: string, version: number, request: AssignOwnerReq) =>
    (await axios.put(`/internal/credit/requests/${requestId}/owner?version=${version}`, request))

  export type UpdateActualHoursReq = {
    actualHours: number
  }

  export const updateCreditRequestActualHours = async (requestId: string, version: number, request: UpdateActualHoursReq) =>
    (await axios.put(`/internal/credit/requests/${requestId}/actual-hours?version=${version}`, request))

  export const pauseCreditRequest = async (requestId: string, version: number) =>
    (await axios.put(`/internal/credit/requests/${requestId}/pause?version=${version}`))

  export const resumeCreditRequest = async (requestId: string, version: number) =>
    (await axios.put(`/internal/credit/requests/${requestId}/resume?version=${version}`))

  export type ResolveReq = {
    actualHours: number
    resolution: string
  }

  export const resolveCreditRequest = async (requestId: string, version: number, request: ResolveReq) =>
    (await axios.put(`/internal/credit/requests/${requestId}/resolve?version=${version}`, request))

  export const cancelCreditRequest = async (requestId: string, version: number) =>
    (await axios.put(`/internal/credit/requests/${requestId}/cancel?version=${version}`))

  export const queryCreditRequestAttachments = async (requestId: string) =>
    (await axios.get<CreditRequestAttachmentModel[]>(`/internal/credit/requests/${requestId}/attachments`)).data

  export type CreateAttachmentReq = {
    fileName: string
    contentType: string
    key: string
  }

  export const createCreditRequestAttachment = async (requestId: string, request: CreateAttachmentReq) =>
    (await axios.post(`/internal/credit/requests/${requestId}/attachments`, request))
}
